import React from "react";
import { TouchableNativeFeedback, View, StyleSheet } from "react-native";
import Text from "@components/AppText";
import BellIcon from "@assets/svg/BellIcon";
import { normalize } from "./metrics";

const NotifyButton = ({ width, onPress, style = {} }) => {
  return (
    <TouchableNativeFeedback onPress={onPress}>
      <View
        style={[
          styles.container,
          {
            width,
          },
          style,
        ]}
      >
        <BellIcon />
        <Text style={styles.text}>सूचित करें</Text>
      </View>
    </TouchableNativeFeedback>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    borderWidth: 1,
    borderRadius: 6,
    borderColor: "#E40046",
    height: normalize(30),
  },
  text: {
    fontSize: normalize(14),
    color: "#E40046",
    marginLeft: 5,
  },
});

export default NotifyButton;
